export const getBadgeOffset = (userAvatarSize: number): [number, number] => {
  const circleRadius = userAvatarSize * 0.5;

  const coordinate = (Math.sqrt(2) / 2) * circleRadius;

  const leftOffset = -(circleRadius - coordinate);
  const topOffset = circleRadius + coordinate;

  const output: [number, number] = [leftOffset, topOffset];
  return output;
};

export const prepareStatus = (
  empStatus: string | null
): 'success' | 'default' | 'processing' | 'error' | 'warning' | undefined => {
  if (!!empStatus && empStatus.toLowerCase() === 'active') {
    return 'success';
  }

  return undefined;
};
